module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAABQAQMAAAAKpfr2AAAABlBMVEXSKBTSTxVAavaZAAABUElEQVRIx+1TQU7DMBDcOCmxEGp87K0VJ7jxg/jCO+AB/CG+8Bd+Qb7AD/oDKoFQJJIuab0Ntb1uQRUnsoes4x3v7O7YAJwlWG9cvipqNg4FGgsoPYAmX+HW5Y0LSEDRqmxtoqbSEQoCtLifQcphmVvAvOsMnyFfWwCu3f1FAGi5FgBEURCgcRJ8801T2wyu+BLggrrF5f5upnxcid4gswDgdikCRRB4KXaS+mPQQYIODlmFPYWOx9M+/mlMHDDpAa+PbgbpuA3FC3s2G4p8ftesmEMRd74WyfZ7Tn/YeWpmni/fqoatYXf35suPGXBXSjxREeaB1+KafA6Sf3e31M4UFD/DK5rvzG98GDJR3EBEiUsC3MdkkvZgUouwPtusPZpGhSaGMy6mwscRN34I5hhgtF9Y8vcUQh9DyFMplPlBGYejC9DZiVVMxus02r+2LwH0WzKexl5kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsnav_img1.png
// module id = hoVA
// module chunks = 1